import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import CountryFlagAndName from '../../components/countryFlagAndName.js'
import FlashMessages, {FlashMessageData} from '../../components/flashMessages.js';
//import DomainReference from '../../components/domainReference.js'
import {_printDate, _printShortFullDate, _printNumber} from '../../helpers/helpers.js'
import imageOnError from '../../helpers/imgOnError.js';

import {RtApiResult, RtVerifiedDomainsPageResult} from '../../../../server/routes/user.js'
import { APIResponse } from '../../../../server/routes/route-types.js';

// Interface for page data
// interface VerifiedDomainsPageData {
//     VerifiedDomains: string[];
// }

// Interface for component props
interface VerifiedDomainsProps {
	server: string;
    pageData: unknown;
}

// // Interface for verified domain table props
interface VerifiedDomainTableProps {
     domainList: string[];
}

// // Interface for domain row props
interface DomainRowProps {
     domain: string;
}

// // Interface for verified domain reference props
interface VerifiedDomainReferenceProps {
     domain: string;
     openProtocol: string;
     title: string;
}

// // Interface for API response
// interface APIResponse {
//     err?: string;
//     results?: {
//         success_msg?: string;
//     };
// }

export default function VerifiedDomains({pageData}: VerifiedDomainsProps) {

	let [data, setData] = useState(pageData as RtVerifiedDomainsPageResult);


	const [flashProps, setFlashProps] = useState<FlashMessageData>({});
	const [selectedDomain, setSelectedDomain] = useState<string>('');

	function VerifiedDomainTable({domainList}: VerifiedDomainTableProps) {
		if (!domainList) return (<></>);
		if (!domainList.length) return (<><p>There are currently no verified domains.</p></>);
	
		return (
			<>
			
				<div className="table-outer table-rounded table-responsive-lg">
				<table className="table-custom table-custom-striped table-custom-primary  ">
					<thead>
					<tr>			
						<th style={{width: '90%'}}>Domain</th>
						<th style={{width: '10%'}}></th>	
					</tr>
					</thead>
						<tbody>
							{
							domainList.map((domain: string, indexKey: number) => {
								return (
									<DomainRow domain={domain} key={indexKey} />
								)
							})
						}	
					</tbody>
				</table>	
				</div>
	
			</>
		)
	}
	
	function DomainRow({domain}: DomainRowProps) {

		if (domain == undefined) return (<></>);

		const d = domain.trim();
	
		return (
	
			<>
				<tr>		
					<td>
						<VerifiedDomainReference 
							domain={d} 
							openProtocol={'https'} 
							title={`${domain} information and technology stack`}
						/>
					</td>
					<td>
						<button 
							 style={{ marginLeft: "auto", float: 'right' }} 
							type="button" 
							className="btn btn-danger" 
							data-toggle="modal" 
							data-domain={d}
							data-target="#modalConfirm"
							onClick = {(event: React.MouseEvent) => setSelectedDomain( d ) }
						>
							X
						</button>
					</td>	
				</tr>		
			</>
		)
	}

	function handleDeleteClick(event: React.MouseEvent): void {
		var domain = selectedDomain;	
		event.preventDefault();

	// http://localhost:3001/user/verified-domains/api-remove-domain?domain=webtechsurvey.com
	
		fetch( `/user/verified-domains/api-remove-domain?domain=${domain}`, {
			method: "GET",
			body: null
		}).then((response: Response) => {
			return response.json();
		}).then((untypedData: unknown) => {

			const data = untypedData as APIResponse<RtApiResult>;
			console.log(data);
	
			if (data.err) {
				setFlashProps({error_msg: data.err})
			}
			else
			{
				if (data.results?.success_msg != undefined && data.results.success_msg.length)  {
					setFlashProps({success_msg: data.results.success_msg} );
					window.location.reload();
				} else {
					setFlashProps({error_msg: 'Unexpected error'})
				}
			}
		}).catch((e: unknown) => {
			setFlashProps({error: 'Unexpected error'});
		});
	}
	
	function ConfirmDeleteAccountModal() {
		return (<>
			<div className="modal fade" id="modalConfirm" tabIndex={-2} role="dialog" aria-labelledby="modalConfirmLabel" aria-hidden="true">
				<div className="modal-dialog modal-dialog-centered" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="modalConfirmLabel">Please Confirm</h5>
							<button type="button" className="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div className="modal-body">
							Are you sure you want to delete the website from monitoring list? Once website is deleted all the change history is lost.
						</div>
						<div className="modal-footer">
							<button 
								type="button" 
								className="btn btn-primary" 
								data-dismiss="modal" 
								id="btn-delete-account"
								onClick={(event: React.MouseEvent) => handleDeleteClick(event)}>Delete Website</button>
							<button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
						</div>
					</div>
				</div>
			</div>
		</>)    
	}

	return (
		<>   
		<section className="section section-sm">
		<div className="container">  
			<div className="row row-50">
				<div className="col-md-10 col-lg-10 col-xl-10">
				<h3>Verified Domains</h3>
				Domains with confirmed domain ownership, ready to be configured for security scans and monitoring.
				<FlashMessages props={flashProps} />
				<ConfirmDeleteAccountModal />
				<VerifiedDomainTable domainList={data.VerifiedDomains} />			
				</div>	          
			</div>


			<div className="row row-50">
				<div className="col-md-10 col-lg-10 col-xl-10">
					<Link 
						className="btn btn-primary" 
						title='Verified Websites list'
						to={'/user/verified-domains/add-domain'}
						style={{ marginLeft: "auto", float: 'right' }} 
					>
					Verify Domain Ownership
					</Link>					
				</div>	
			</div>	
			</div> 
            </section>
		</>
	)
};




function VerifiedDomainReference({domain, openProtocol, title}: VerifiedDomainReferenceProps) {

	// if title not defined ... use default title
	const realTitle: string = 
		(title && title.length > 0) ? 
			title :
			`${domain} technology stack and statistics`;


	return (
		<>
			<img 
				src={`https://www.google.com/s2/favicons?domain=${domain}`} 
				onError={imageOnError}       
				width="16"
				height="16"
			/>
			<Link 
				className="link-hover word-break" 
				title={realTitle} 
				to={`/monitoring/${domain}`}
			>
				{' '}{domain}{' '}
			</Link>
			{/* No <Link>! this is external reference */}
			<a
				target="_blank" 
				rel="noopener nofollow noreferrer" 
				href={`${openProtocol}://${domain}/`}
			>
				<span className="icon text-right fa fa-external_link"></span>
			</a>
		</>
	)
}